/* pg-form */
(function(){
  if (window.pgForm) return; window.pgForm = 1;

  var FORM = "#content form[action*='contact']";
  var FIELDS = FORM + " input, " + FORM + " textarea, " + FORM + " select";
  var SENDS = FORM + " button, " + FORM + " input[type='submit']";
  var SKIP = {checkbox: 1, radio: 1, submit: 1, hidden: 1, button: 1, image: 1, file: 1};

  var REST = {
    'background-color': '#140C1E',
    'color': '#F1EDF7',
    'border': '1.5px solid rgba(139,68,190,.55)',
    'border-radius': '12px',
    'box-shadow': '0 0 0 1px rgba(139,68,190,.14), 0 0 18px -6px rgba(139,68,190,.55)',
    'outline': 'none',
    'transition': 'border-color .15s ease, box-shadow .15s ease, background-color .15s ease'
  };

  var FOCUS = {
    'background-color': '#1A1026',
    'color': '#F1EDF7',
    'border': '1.5px solid #C79BEA',
    'border-radius': '12px',
    'box-shadow': '0 0 0 3px rgba(139,68,190,.28), 0 0 28px -4px rgba(199,155,234,.65)',
    'outline': 'none'
  };

  var HOVER = {
    'border': '1.5px solid rgba(199,155,234,.75)',
    'box-shadow': '0 0 0 1px rgba(139,68,190,.2), 0 0 22px -5px rgba(139,68,190,.7)'
  };

  var BOX = {
    'accent-color': '#8B44BE',
    'width': '18px',
    'height': '18px',
    'border': '1.5px solid rgba(139,68,190,.6)',
    'box-shadow': '0 0 12px -4px rgba(139,68,190,.7)',
    'cursor': 'pointer'
  };

  var SEND = {
    'background': 'linear-gradient(120deg,#9B4BC4 0%,#7A2FA2 50%,#4A1C66 100%)',
    'background-color': '#7A2FA2',
    'background-image': 'linear-gradient(120deg,#9B4BC4 0%,#7A2FA2 50%,#4A1C66 100%)',
    'color': '#FFFFFF',
    '-webkit-text-fill-color': '#FFFFFF',
    'border': 'none',
    'border-radius': '999px',
    'padding': '13px 34px',
    'font-weight': '800',
    'font-size': '14px',
    'letter-spacing': '.06em',
    'text-transform': 'uppercase',
    'cursor': 'pointer',
    'outline': 'none',
    'box-shadow': '0 0 0 1px rgba(199,155,234,.35), 0 10px 30px -12px rgba(155,75,196,.75)',
    'transition': 'box-shadow .15s ease, filter .15s ease'
  };

  var SEND_HOVER = {
    'filter': 'brightness(1.12)',
    'box-shadow': '0 0 0 2px rgba(199,155,234,.55), 0 14px 34px -10px rgba(155,75,196,.9)'
  };

  function stamp(el, set){
    for (var k in set) el.style.setProperty(k, set[k], 'important');
  }

  /* label colour lives on the button's children in some renderings */
  function whiteText(btn){
    stamp(btn, {'color': '#FFFFFF', '-webkit-text-fill-color': '#FFFFFF'});
    btn.querySelectorAll('*').forEach(function(kid){
      stamp(kid, {'color': '#FFFFFF', '-webkit-text-fill-color': '#FFFFFF'});
    });
  }

  function armSend(){
    document.querySelectorAll(SENDS).forEach(function(btn){
      if (btn.dataset.pgSend){ whiteText(btn); return; }
      btn.dataset.pgSend = '1';
      stamp(btn, SEND);
      whiteText(btn);
      btn.addEventListener('mouseenter', function(){ stamp(btn, SEND_HOVER); });
      btn.addEventListener('mouseleave', function(){
        stamp(btn, {'filter': 'none', 'box-shadow': SEND['box-shadow']});
      });
    });
  }

  function arm(){
    document.querySelectorAll(FIELDS).forEach(function(el){
      var t = (el.getAttribute('type') || el.type || 'text').toLowerCase();
      if (el.dataset.pgField) return;
      el.dataset.pgField = '1';

      if (t === 'checkbox' || t === 'radio'){
        stamp(el, BOX);
        el.style.setProperty('border-radius', t === 'radio' ? '50%' : '5px', 'important');
        return;
      }
      if (SKIP[t]) return;

      stamp(el, REST);
      el.addEventListener('focus', function(){ stamp(el, FOCUS); });
      el.addEventListener('blur', function(){ stamp(el, REST); });
      el.addEventListener('mouseenter', function(){
        if (document.activeElement !== el) stamp(el, HOVER);
      });
      el.addEventListener('mouseleave', function(){
        if (document.activeElement !== el) stamp(el, REST);
      });
    });
    armSend();
  }

  /* the contact section can render late, and the theme re-stamps its own inline
     styles on some fields after load, so this keeps a slow watch */
  setInterval(arm, 800);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arm); else arm();
})();
